module.exports = {"341221001":"城关街道","341221002":"邢塘街道","341221003":"田桥街道","341221004":"城东街道","341221005":"城南街道","341221101":"杨桥镇","341221102":"鲖城镇","341221103":"谭棚镇","341221104":"老集镇","341221105":"滑集镇","341221106":"吕寨镇","341221107":"单桥镇","341221108":"长官镇","341221109":"宋集镇","341221110":"张新镇","341221111":"艾亭镇","341221112":"陈集镇","341221113":"韦寨镇","341221114":"迎仙镇","341221115":"瓦店镇","341221116":"姜寨镇","341221117":"庙岔镇","341221118":"黄岭镇","341221119":"白庙镇","341221120":"关庙镇","341221122":"高塘镇","341221203":"土陂乡","341221206":"陶老乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341221.json
// module id = 1123
// module chunks = 0